import { always } from "../../../base/utils/ramdaEquivalents.utils";
import { makeObservableRouteDef } from "../../../base/utils/routes.utils";
import PageLogin from "./Login.page";

export const LoginPageRoute = makeObservableRouteDef({
  identifier: 'login',
  urlFactory: always('login'),
  composeTitle: always('Login'),
  component: PageLogin,
})